import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CatCategoryPromoterModel } from 'src/app/model/cat-category-promoter.model';

@Injectable({
  providedIn: 'root'
})
export class CatCategoryPromoterService {
  private url:string;

  ////////////////
  constructor(
    private http:HttpClient
  ) {
    this.url=environment.services_url;
  }

  //
  catalog=()=> {
    return this.http.get(`${this.url}/CatPromoterCategory/Catalog`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getAll=()=> {
    return this.http.get(`${this.url}/CatPromoterCategory/List`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getAllActive=()=> {
    return this.http.get(`${this.url}/CatPromoterCategory/List`)
      .pipe(
        map((resp:any)=> resp.filter(cat=> cat.activeId))
      );
  }


  save=(category:CatCategoryPromoterModel)=> {
    return this.http.post(`${this.url}/CatPromoterCategory/SaveUpdate`, category)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  update=(category:CatCategoryPromoterModel)=> {
    return this.http.post(`${this.url}/CatPromoterCategory/SaveUpdate/${category.promoterCategoryId}`, category)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  upload=(userName: string, file: File, replace: boolean)=> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('userName', userName);
    formData.append('table', 'catPromoterCategory');
    formData.append('replace', String(replace));
    formData.append('userId', localStorage.getItem('com_token'));
    return this.http.post(`${this.url}/upload/save`, formData)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  downloadLayout = () => this.http.get(`${this.url}/CatPromoterCategory/DownloadLayout`, { responseType: 'blob' });
}